import { createRicosFunctionalExtension } from 'wix-tiptap-extensions';

import * as deleteNode from './commands/deleteNode';
import * as insertNode from './commands/insertNode';
import * as normalizeNodes from './commands/normalizeNodes';
import * as replaceNode from './commands/replaceNode';
import * as replaceNodes from './commands/replaceNodes';
import * as setNodeAttrsById from './commands/setNodeAttrsById';
import * as splitBlock from './commands/splitBlock';
import * as toggleTextNode from './commands/toggleTextNode';
import * as updateAttributesWithDeepMerge from './commands/updateAttributesWithDeepMerge';
import * as updateNodeAttrsById from './commands/updateNodeAttrsById';
import * as updateTextNode from './commands/updateTextNode';

export const commands = createRicosFunctionalExtension({
  type: 'extension',
  groups: [],
  name: 'ricos-node-commands',
  createExtensionConfig() {
    return {
      name: this.name,
      addCommands() {
        return {
          ...insertNode,
          ...updateTextNode,
          ...toggleTextNode,
          ...normalizeNodes,
          ...setNodeAttrsById,
          ...updateNodeAttrsById,
          ...deleteNode,
          ...replaceNode,
          ...replaceNodes,
          ...updateAttributesWithDeepMerge,
          ...splitBlock,
        };
      },
    };
  },
});
